module.exports = __webpack_public_path__ + "img/David Tran.ae76d5af.png";